<template>
  <div class="search-item">
    <div
      v-if="title"
      class="search-item-title"
    >
      <span>{{ title }}</span>
    </div>
    <div class="search-item-content">
      <slot />
    </div>
    <div style="clear: both;" />
  </div>
</template>

<script>
export default {
  name: 'SearchItem',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
  .search-item {
    display: inline-block;
    line-height: 32px;
  }

  .search-item-title {
    float: left;
    margin-right: 10px;
  }

  .search-item-content {
    float: left;
  }

  .search-item-content >>> .ant-input,
  .search-item-content >>> .ant-select,
  .search-item-content >>> .mini .ant-calendar-picker-input {
    width: 180px;
  }

  .search-item-content >>> .ant-calendar-picker-input {
    width: 350px;
  }

  .search-item-content >>> .single .ant-calendar-picker-input {
    width: 195px;
  }

  .search-item-content >>> .short .ant-calendar-picker-input {
    width: 220px;
  }
</style>
